import { render, staticRenderFns } from "./heijing.vue?vue&type=template&id=62e84b12&scoped=true&"
import script from "./heijing.vue?vue&type=script&lang=ts&"
export * from "./heijing.vue?vue&type=script&lang=ts&"
import style0 from "./heijing.vue?vue&type=style&index=0&id=62e84b12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e84b12",
  null
  
)

export default component.exports